import styled from 'styled-components';

import {Stack} from '@edna/components/primitives';

export const ScrollContainer = styled(Stack).attrs((props) => ({size: '4', ...props}))`
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: ${({theme}) => theme.spacing.s1};
`;
